export default __webpack_public_path__ + "static/media/Surfacelight.9a0d07bc.jpg";